import { render, staticRenderFns } from "./SortLetterDown.vue?vue&type=template&id=0f7ef373"
import script from "./SortLetterDown.vue?vue&type=script&lang=js"
export * from "./SortLetterDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports